// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__39DY0","title":"AfterBackImages_title__11osF","images":"AfterBackImages_images__LCvs_"};